/* eslint-disable max-classes-per-file */

import { ABaseModel, MapType } from '@pperform/pp-data-mappers';

export enum PhaseEventsVisibility {
  DISPLAY = 'display',
  HIDE = 'hide',
}

class PtpEventVisibility extends ABaseModel {
  phaseAEventsVisibility: PhaseEventsVisibility = PhaseEventsVisibility.HIDE;

  phaseBEventsVisibility: PhaseEventsVisibility = PhaseEventsVisibility.HIDE;

  phaseCEventsVisibility: PhaseEventsVisibility = PhaseEventsVisibility.HIDE;
}

class ReturnManagement extends ABaseModel {
  enableReturnManagement = false;

  enablePreprintedReturnLabel = false;
}

class CampaignManager extends ABaseModel {
  enable = false;
}

export class FeatureToggles extends ABaseModel {
  @MapType(PtpEventVisibility)
  ptpEventVisibility: PtpEventVisibility = new PtpEventVisibility();

  @MapType(ReturnManagement)
  returnManagement: ReturnManagement = new ReturnManagement();

  @MapType(CampaignManager)
  campaignManager: CampaignManager = new CampaignManager();
}
